export default {
  path: '/review',
  component: () => import('../components/Index'),
  children: [
    {
      path: "/",
      redirect: "content",
    },
    // {
    //   path: "index",
    //   component: () => import('../components/review/Index'),
    // },
    {
      path: "content",
      component: () => import('../components/review/Content'),
    },
    {
      path: "question-check",
      component: () => import('../components/review/QuestionCheck'),
    }
  ]
}


// WEBPACK FOOTER //
// ./src/pages/pc/router/review.js